// @angular/core
import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
	selector: '[clickOutsideElement]'
})
export class ClickOutsideElementDirective {

	@Output() clickOutsideElement: EventEmitter<MouseEvent> = new EventEmitter();

	constructor(
		private _elementRef: ElementRef
	) {}

	@HostListener('document:click', ['$event', '$event.target'])
	public onClick(event: MouseEvent, targetElement: HTMLElement) {
		if ( !targetElement ) {
			return;
		}

		const clickedInsideElement: boolean = this._elementRef.nativeElement.contains(targetElement);

		if ( !clickedInsideElement ) {
			this.clickOutsideElement.emit(event);
		}
	}
}
